import {Component, OnInit} from '@angular/core';
import {Session} from '../../domain/session';
import {SessionService} from '../../../core/services/sessionService';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {Response} from '../../domain/Response';

declare const gapi: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
    public auth2: any;
    constructor(private sessionService: SessionService, public router: Router, private toastr: ToastrService) {}
    public googleInit() {
        gapi.load('auth2', () => {
            this.auth2 = gapi.auth2.init({
                client_id: '70680881927-jmgpq0c0pmpmb6l7u0sdsh1jravaln7b.apps.googleusercontent.com',
                cookiepolicy: 'http://www.tickets.unsam.edu.ar',
                scope: 'profile email',
                prompt: 'select_account'
            });
            this.attachSignin(document.getElementById('googleBtn'));
        });
    }
    public attachSignin(element) {
        this.auth2.attachClickHandler(element, {},
            (googleUser) => {
                const profile = googleUser.getBasicProfile();
                this.sendRequest(profile);
            });
    }
    ngOnInit() {
        this.googleInit();
    }

    sendRequest(profile) {
            this.sessionService.checkToWhiteList(profile.getEmail()).subscribe(
                (resp: Response) => {
                    if(resp.error != ""){
                        this.router.navigate(['/errorLogin',resp.error]);
                    } else {
                        const session = {
                            idGoogle:  profile.getId(),
                            email: profile.getEmail(),
                            name: profile.getName(),
                            imgUrl: profile.getImageUrl(),
                            id: resp.data.id,
                            type: resp.data.type
                        }
                        this.toastr.success('Sesión iniciada', 'Exito');
                        this.sessionService.initSession(session);
                    }
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/login/login.component.ts